import { useEffect, useState } from "react";
import { GET_LAWYERS_BY_SUBURB } from "../api/constants";

const useLawyersBySuburb = ({ suburbId = null, enabled = true } = {}) => {
  const [lawyers, setLawyers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !suburbId) {
      setLawyers([]);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchLawyers = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${GET_LAWYERS_BY_SUBURB}/${suburbId}`);
        const data = await response.json();

        if (Array.isArray(data?.data)) {
          setLawyers(data.data);
        } else if (Array.isArray(data)) {
          setLawyers(data);
        } else {
          setLawyers([]);
        }
      } catch (err) {
        console.error("Error fetching lawyers by suburb:", err);
        setError(err);
        setLawyers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLawyers();
  }, [suburbId, enabled]);

  return { lawyers, loading, error };
};

export default useLawyersBySuburb;
